import * as React from 'react';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { useAnalyticsQueue } from '@invitae/nucleobase-analytics';

/* eslint-disable @typescript-eslint/naming-convention */
var usePageAnalytics = function (_a) {
    var analyticsEvents = _a.analyticsEvents, pageSignature = _a.pageSignature, url = _a.url, siteLocation = _a.siteLocation;
    var logEvent = useAnalyticsQueue().logEvent;
    /** we track last scrolled position as a ref instead of using
     * state so as not to trigger re-renders in the components that
     * call this hook
     * */
    var lastScrollPositionRef = React.useRef(0);
    useScrollPosition(function () {
        var domElement = document.documentElement;
        /** scrollPosition in percentage (so if user scrolls half the page
         * it will be 50% if user scrolls to the end of the page it will be 100%)
         * */
        var scrollPosition = Math.ceil(Math.round((domElement.scrollTop / (domElement.scrollHeight - domElement.clientHeight)) * 100) / 10) *
            10;
        if (lastScrollPositionRef.current === scrollPosition) {
            return;
        }
        if (!isNaN(scrollPosition)) {
            lastScrollPositionRef.current = scrollPosition;
        }
        /** for each registered on scroll event
         *  we want to send an event with scroll information and Page signature
         * */
        analyticsEvents === null || analyticsEvents === void 0 ? void 0 : analyticsEvents.filter(function (e) { return e.fields.type === 'scroll'; }).forEach(function (e) {
            logEvent({
                eventName: e.fields.name,
                eventProperties: {
                    'Page signature': pageSignature,
                    scroll: scrollPosition,
                    'Site location': siteLocation,
                    url: url,
                },
            });
        });
    }, [analyticsEvents, lastScrollPositionRef]);
    /** for each registered onLoad event
     *  we want to send an event with with url and page signature
     * `referrer` should help us track loads that are coming through redirects
     * */
    React.useEffect(function () {
        analyticsEvents === null || analyticsEvents === void 0 ? void 0 : analyticsEvents.filter(function (e) { return e.fields.type === 'load'; }).forEach(function (e) {
            logEvent({
                eventName: e.fields.name,
                eventProperties: {
                    'Page signature': pageSignature,
                    referrer: document ? document.referrer : '',
                    'Site location': siteLocation,
                    url: url,
                },
            });
        });
    }, [analyticsEvents, url, siteLocation, logEvent, pageSignature]);
};
/* eslint-enable @typescript-eslint/naming-convention */

export { usePageAnalytics };
//# sourceMappingURL=Page.hooks.esm.js.map
